/* eslint-disable no-console */
import {Row, Col} from 'antd';
import React, {useState} from 'react';

import Loader from '../../../../../components/Loader/Loader';
import MapComp from '../../../../../components/MapComponents/MapComp';

import FacilityMapData from './FacilityMapData';

const MapView: React.FC<{
  data: any[];
  setEditData: React.Dispatch<any>;
  setIsEdit: React.Dispatch<React.SetStateAction<boolean>>;
  handleDelete: (_id: string[] | string) => void;
  setShowModel: React.Dispatch<React.SetStateAction<boolean>>;
  isLoading: boolean;
  noEdit?: boolean;
}> = ({
  data,
  handleDelete,
  setEditData,
  setIsEdit,
  isLoading,
  setShowModel
}) => {
  const [selectedFacility, setSelectedFacility] = useState<
    string | undefined
  >();

  const mapRef: any[] = [];

  return isLoading ? (
    <Loader />
  ) : (
    <div className="facilityMapMainFlex">
      <Row gutter={[16, 16]}>
        <Col span={8}>
          <FacilityMapData
            data={data}
            mapRef={mapRef}
            handleDelete={handleDelete}
            setEditData={setEditData}
            setIsEdit={setIsEdit}
            setShowModel={setShowModel}
            selectedFacility={selectedFacility}
            setSelectedFacility={setSelectedFacility}
          />
        </Col>
        <Col span={16}>
          <MapComp
            type="facilityMap"
            mapData={data}
            markerRef={mapRef}
            center={data?.[0]?.coordinates ?? undefined}
            setSelectedFacility={setSelectedFacility}
          />
        </Col>
      </Row>
    </div>
  );
};

export default MapView;
